import { render } from "./AdvancedSearch.vue?vue&type=template&id=070cf2a2&scoped=true"
import script from "./AdvancedSearch.vue?vue&type=script&lang=js"
export * from "./AdvancedSearch.vue?vue&type=script&lang=js"

import "./AdvancedSearch.vue?vue&type=style&index=0&id=070cf2a2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-070cf2a2"

export default script